import { DateTime } from 'luxon'
import { useFlag } from '@openfeature/react-sdk'

import { FEATURE_FLAG_KEYS } from '@/flags'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { parseAnnouncementFlag } from '@/features/user/dashboard/feature-announcement/useFeatureAnnouncement'

export const HEARD_BANKING_GA_ANNOUNCEMENT_ID = 'heard_banking_ga'

const PACIFIC_ZONE = 'America/Los_Angeles'

type ParsedAnnouncement = ReturnType<typeof parseAnnouncementFlag>

export const isHeardBankingGaAnnouncement = (
  parsed: ParsedAnnouncement
): boolean =>
  parsed.ok &&
  parsed.resolved.announcement.announcementId ===
    HEARD_BANKING_GA_ANNOUNCEMENT_ID

export interface PromoDeadline {
  date: string
  time: string
}

export const formatPromoDeadline = (
  endTimestamp: string | undefined
): PromoDeadline | null => {
  if (!endTimestamp) return null
  const end = DateTime.fromISO(endTimestamp).setZone(PACIFIC_ZONE)
  if (!end.isValid) return null
  return {
    date: end.toFormat(DATE_FORMATS_LUXON.MONTH_DAY_LONG),
    time: end.toFormat(DATE_FORMATS_LUXON.TIME_NO_SPACE).toLowerCase(),
  }
}

export interface HeardBankingPromo {
  isActive: boolean
  deadline: PromoDeadline | null
  disclaimer: string | null
}

export const useHeardBankingPromo = (): HeardBankingPromo => {
  const { value } = useFlag(FEATURE_FLAG_KEYS.featureAnnouncement, {})
  const parsed = parseAnnouncementFlag(value, new Date())
  const isActive = isHeardBankingGaAnnouncement(parsed)
  const deadline =
    isActive && parsed.ok
      ? formatPromoDeadline(parsed.resolved.announcement.endTimestamp)
      : null
  const disclaimer =
    isActive && parsed.ok
      ? (parsed.resolved.announcement.disclaimer ?? null)
      : null
  return { isActive, deadline, disclaimer }
}
